import React, { useLayoutEffect } from 'react'
import { parseAuthHash } from '../../../routes'
import { withRouter } from '../with-router'

const callBack = (props) => {
  useLayoutEffect(() => {
    const { location, params, navigate } = props
    parseAuthHash(location, params, navigate)
  }, [])

  return (
    <div className='login callback'>
      <span className='callback__spinner' aria-hidden='true' />
      <h2 className='callback__title'>Signing you in&hellip;</h2>
    </div>
  )
}
export default withRouter(callBack)
